// extracted by mini-css-extract-plugin
module.exports = {"buyChip":"LandaFinancingFormMobile_buyChip__4o1gZ","buyDialogMobile":"LandaFinancingFormMobile_buyDialogMobile__uAK8P"};